import { veryDissatisfied, dissatisfied, partlySatisfied, satisfied, verySatisfied } from "../../../icons.tsx";
import { exhaustiveGuard } from "../../../utilities.ts";

export interface EvaluationStatusSaveModel {
    evaluationStatus?: EvaluationStatus;
    evaluation?: string;
}

export enum EvaluationStatus {
    VeryDissatisfied = 1,
    Dissatisfied = 2,
    PartlySatisfied = 3,
    Satisfied = 4,
    VerySatisfied = 5,
}

export function getEvaluationIcon(status: EvaluationStatus) {
    switch (status) {
        case EvaluationStatus.VeryDissatisfied:
            return veryDissatisfied;
        case EvaluationStatus.Dissatisfied:
            return dissatisfied;
        case EvaluationStatus.PartlySatisfied:
            return partlySatisfied;
        case EvaluationStatus.Satisfied:
            return satisfied;
        case EvaluationStatus.VerySatisfied:
            return verySatisfied;
        default:
            exhaustiveGuard(status);
    }
}
